import React from 'react';
import styles from './HelperText.module.css';

/**
 * HelperText - Atom component for field helper/hint text
 * Used when the IDS component doesn't support helperText prop directly
 *
 * @param {string} text - Helper text to display
 * @param {boolean} error - Whether to show error styling
 * @param {string} className - Additional CSS class names
 */
const HelperText = ({ text, error = false, className = '' }) => {
  if (!text) return null;

  return (
    <div
      className={`${styles.helperText} ${error ? styles.error : ''} ${className}`.trim()}
    >
      {text}
    </div>
  );
};

export default HelperText;
